import { removeParams, addParams } from './query';
import { getReferrer } from './referrer';

const vehicleParams = [
  'year',
  'make',
  'model',
  'trim',
  'vin',
  'licensePlate',
  'plateState',
  'referrer'
];

const buildNavigationUrl = ({
  baseUrl = '',
  paramsToAdd = {},
  paramsToRemove = [],
  initialSearch = '',
  includeReferrer = true
}): string => {
  if (typeof window === 'undefined') {
    return `${baseUrl}`;
  }

  const search = initialSearch || (window?.location?.search ?? '');
  const allParamsToRemove = [...paramsToRemove, ...vehicleParams];
  const allParamsToAdd = {
    ...paramsToAdd,
    ...(includeReferrer && { referrer: getReferrer()?.match?.slice(1) })
  };
  const filteredSearch = removeParams(search, allParamsToRemove);
  const hydratedSearch = addParams(filteredSearch, allParamsToAdd);
  return `${baseUrl}${hydratedSearch}`;
};

export { buildNavigationUrl };
